import Http from "../Http";
import { INSPECTION_URL } from "../Helper";

export function getManufPanelReportData(user_id) {
    return (dispatch) =>
      new Promise((resolve, reject) => {
        Http.get(INSPECTION_URL + 'get_user_meta_manufpanel/'+user_id )
          .then((res) => {
            console.warn('InspectorData', res.data)
            return resolve(res.data);
          })
          .catch((err) => {
            return reject(err);
          });
      });
  }